export default __webpack_public_path__ + "static/media/dress4.fa2d4833.jpeg";